import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import HomePage from "./components/pages/HomePage";
import About from "./components/pages/AboutUs";
import Navbar from "./components/primitives/Navbar";
import Footer from "./components/primitives/Footer";
import "./App.css";

function App() {
  const location = useLocation();
  
  // This effect runs once when component mounts
  useEffect(() => {
    // Function to force scroll to top
    const forceScrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Initial scroll to top - run immediately
    forceScrollToTop();
    
    // Force scroll after a short delay to ensure DOM is ready
    const timer1 = setTimeout(forceScrollToTop, 50);
    const timer2 = setTimeout(forceScrollToTop, 100);
    const timer3 = setTimeout(forceScrollToTop, 200);
    
    // Clean up
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);
  
  // This effect handles route changes
  useEffect(() => {
    // Scroll to top on route change
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
    
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <main className="min-h-screen flex flex-col scroll-smooth m-0 w-full overflow-x-hidden">
      <Routes>
        {/* Home Page */}
        <Route path="/" element={<HomePage />} />

        {/* About Page */}
        <Route
          path="/about"
          element={
            <>
              <Navbar />
              <div className="flex-1 m-0 w-full">
                <About />
              </div>
              <footer id="contact" className="w-full">
                <Footer />
              </footer>
            </>
          }
        />

        {/* Catch all other routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
  );
}

export default App;